type FileTypeLimits = {
  sourcePdf: number;
  atlprojImport: number;
  csvSurvey: number;
  sourceEmbeddedImage: number;
  userImage: number;
};

type Config = {
  entityNameMaxlength: number;
  supportedImageMimeTypes: ReadonlyArray<string>;
  supportedSourceMimeTypes: ReadonlyArray<string>;
  sourceJsonMaxSizeMb: number;
  trialDays: number;
  supportedImportFileEndings: ReadonlyArray<string>;
  maxFileSizeMb: FileTypeLimits;
  maxFileSize?: Partial<FileTypeLimits>;
  overallFileSizeLimit?: number;
  supportUrl: `https://${string}`;
  paperSearchFeedbackUrl: `https://${string}`;
  semanticScholarUrl: `https://${string}`;
};

const maxFileSizeMb = {
  sourcePdf: 50,
  atlprojImport: 500,
  csvSurvey: 10,
  sourceEmbeddedImage: 4,
  userImage: 0.25,
} as const satisfies FileTypeLimits;

export const base = {
  entityNameMaxlength: 1000,
  supportedImageMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
  supportedSourceMimeTypes: ['application/pdf'],
  sourceJsonMaxSizeMb: 8,
  trialDays: 5,
  supportedImportFileEndings: ['atlproj9', 'atlproj22', 'atlproj23', 'atlasti'],
  maxFileSizeMb,
  overallFileSizeLimit: Math.max(...Object.values(maxFileSizeMb)) * 1000000,
  maxFileSize: Object.entries(maxFileSizeMb).reduce((acc, [key, value]) => {
    acc[key] = value * 1024 * 1024;

    return acc;
  }, {}) as FileTypeLimits,
  supportUrl: 'https://atlasti.com/support',
  paperSearchFeedbackUrl: 'https://tally.so/r/mKM788',
  semanticScholarUrl: 'https://semanticscholar.org',
} as const satisfies Config;

const getData = (): typeof base => base;

export const config = getData();
